import IntlHelper from '../../../helper/IntlHelper'
import { type FC } from 'react'
import styles from './UnitCard.module.scss'

interface UnitCardProps {
  id: number
  model: string
  price: number
  pricePer: string
  image: string
  description: string
  selected: number | null
  selectUnit: (id: number) => any
}

const intlHelper = new IntlHelper()

const UnitCard: FC<UnitCardProps> = ({
  id,
  model,
  price: pricePerHour,
  pricePer,
  image,
  description,
  selected,
  selectUnit
}: UnitCardProps) => (
  <div
    className={`${selected === id ? styles.UnitCardAdded : styles.UnitCard}`}
    data-testid='UnitCard'
    onClick={() => selectUnit(id)}
  >
    <a className='model'>
      <dt>{model}</dt>
      <div hidden={pricePerHour === 0}>
        {intlHelper.CurrencyFormat(pricePerHour)} / {pricePer}
      </div>
      <img src={image} />
      <dd>{description}</dd>
    </a>
  </div>
)

export default UnitCard
